import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { SortParams } from 'shared/models/common';
import type { KeyOrdersInitialState } from './types';

const initialState: KeyOrdersInitialState = {
  sortParams: {
    order: 'desc',
    orderBy: 'CreatedOn',
    type: 'date',
  },
  searchTerm: '',
  status: 'all',
  year: 'all',
};

const keyOrdersSlice = createSlice({
  name: 'keyOrders',
  initialState,
  reducers: {
    setSortParams: (state, action: PayloadAction<SortParams>) => {
      state.sortParams = action.payload;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setStatus: (state, action: PayloadAction<string | number>) => {
      state.status = action.payload;
    },
    setYear: (state, action: PayloadAction<string | number>) => {
      state.year = action.payload;
    },
  },
});

export default keyOrdersSlice.reducer;
export const { setSortParams, setSearchTerm, setStatus, setYear } =
  keyOrdersSlice.actions;
